import { lazy } from "react";
// Denials Management & Appeals Module (Módulo G — BillingV2)
// Worklist de denials (835), causa raíz, apelaciones y tracking de recuperación.

const DenialsManagementPage = lazy(() => import("./pages/DenialsManagementPage"));
// Export routes for AppRouter
export const denialsManagementRoutes = [
  {
    path: "/denials-management",
    element: <DenialsManagementPage />,
  },
];

// Export components for external use

// Export utilities
export * from "./common/constants";
